module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_WUR_image_3.450a2f80.png";